/* eslint-disable react-hooks/exhaustive-deps */
import Axios from "axios";
import { useEffect, useState } from "react";

const useAppStatus = () => {
	const [online, setOnline] = useState<boolean>(navigator.onLine);

	const startConnectionWorker = () => {
		let attempt = 0;
		let interval = 1000;
		let intervalId: NodeJS.Timeout;

		const runCheck = async () => {
			console.log("Checking connectivity attempt:", attempt);
			console.log("Current interval:", interval, intervalId);
			const isOnline = await checkConnectivity(intervalId);
			setOnline(isOnline);
			if (!isOnline) {
				attempt += 1;
				interval = Math.min(30000, 1000 * Math.pow(2, attempt)); // Exponential backoff, max 30s
				intervalId = setTimeout(runCheck, interval);
			}
		};

		runCheck();
	};

	const checkConnectivity = (intervalId: ReturnType<typeof setInterval>): Promise<boolean> => {
		return new Promise(async (resolve) => {
			const host = process.env.REACT_APP_API_HOST || "";
			const endpoint = host + `?timestamp=${new Date().getTime()}`;

			try {
				await Axios.head(endpoint);
				clearInterval(intervalId);
				resolve(true);
			} catch (e) {
				resolve(false);
			}
		});
	};

	const handler = (e: Event) => {
		setOnline(navigator.onLine);
	};

	useEffect(() => {
		window.addEventListener("online", handler);
		window.addEventListener("offline", handler);

		return () => {
			window.removeEventListener("online", handler);
			window.removeEventListener("offline", handler);
		};
	}, []);

	useEffect(() => {
		if (!online) startConnectionWorker();
	}, [online]);

	return { online };
};

export default useAppStatus;
